import { Link } from "react-router-dom";
import { animeCategories } from "@/mocks/anime";

export default function Categories() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="container-x">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-accent-200 bg-accent-100 px-3 py-1 text-sm font-medium text-accent-700">
            <i className="ri-folder-open-line"></i>
            按口味分好类
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            挑一个今天的「看番姿势」
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
            不知道看什么？按场景和心情选一个分类，三分钟短番、下饭番、摸鱼短番都在里面等你。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {animeCategories.map((cat) => (
            <Link
              key={cat.id}
              to={`/biaoqian/${cat.id}`}
              className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-100 text-2xl text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={cat.icon}></i>
                </span>
                <span className="text-xs text-foreground-400">{cat.count} 部</span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                {cat.name}
                <span className="ml-2 text-xs font-normal text-foreground-500">{cat.tagline}</span>
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                去看看 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}